import styled from 'styled-components';

const Separator = styled.div`
  position: relative;

  background: ${({ theme, background }) => background || theme.colors.platinum};

  border-bottom: solid ${({ height = '1px' }) => height};

  border-bottom-color: ${({ theme, light }) =>
    light ? theme.colors.elementLightGrey : theme.colors.platinum};

  margin-left: ${({ width = 100 }) => `${100 - width}%`};

  width: ${({ width = 100 }) => `${width}%`};

  ${({ margin = '0', marginTop, marginBottom }) =>
    margin &&
    `margin-top: ${marginTop || margin};
    margin-bottom: ${marginBottom || margin};
`};
`;

export default Separator;
